import { ColumnElement, ColumnTitle } from '@atoms/columnElement';
import { InfoTooltip } from '@atoms/infoTooltip';

import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { Input } from '@components/ui/input';
import { Label } from '@components/ui/label';
import type { BaseEditorOptions } from '@stratumn/studio-shared';
import { observer } from 'mobx-react';
import type { PropsWithChildren } from 'react';

type Props = BaseEditorOptions & {
  onPlaceholderChange: (placeholder: string) => void;

  atomId: string;
  additionalChildren?: React.ReactNode;
};

export const EditorOptions = observer((props: PropsWithChildren<Props>) => (
  <>
    <Column $width="220px">
      <ColumnTitle>Editor options</ColumnTitle>
      {props.children}
      <ColumnElement>
        <div className="flex w-full items-center gap-2">
          <Label htmlFor={`placeholder-${props.atomId}`}>Placeholder</Label>
          <InfoTooltip
            description="The text to display when the cell's editor is empty."
            title="Placeholder"
          />
        </div>

        <Input
          id={`placeholder-${props.atomId}`}
          onChange={e => props.onPlaceholderChange(e.target.value)}
          placeholder="Aa"
          type="text"
          value={props.placeholder}
        />
      </ColumnElement>
    </Column>
    {props.additionalChildren}
  </>
));
